export interface MenuButton {
  url: string;
  title: string;
  class: string;
  ignoreRestrictions?: boolean;
}


export const AllHeaderButtons: MenuButton[] = [{
  url: '/board',
  title: 'Board',
  class: 'board-header-button'
}, {
  url: '/schedule',
  title: 'Schedule',
  class: 'schedule-header-button'
}, {
  url: '/user-schedule',
  title: 'Installation',
  class: 'user-schedule-header-button'
}, {
  url: '/planning',
  title: 'Planning',
  class: 'planning-header-button'
}, {
  url: '/projects',
  title: 'CRM',
  class: 'projects-header-button'
}, {
  url: '/orders/list',
  title: 'Materials/Order',
  class: 'orders-header-button'
}, {
  url: '/timesheets',
  title: 'Timesheets',
  class: 'timesheets-header-button'
}, {
  url: '/users',
  title: 'Users',
  class: 'users-header-button'
}, {
  url: '/logistic',
  title: 'Logistic',
  class: 'logistic-header-button'
}, {
  url: '/reports',
  title: 'Reports',
  class: 'reports-header-button'
}]


export const AllMobileButtons: MenuButton[] = [{
  url: '/board',
  title: 'Kanban Board',
  class: 'board-side-button'
}, {
  url: '/shop/cnc-operator',
  title: 'Shop View',
  class: 'shop-side-button'
}, {
  url: '/schedule',
  title: 'Schedule',
  class: 'schedule-side-button'
}, {
  url: '/user-schedule',
  title: 'Installation',
  class: 'user-schedule-header-button'
}, {
  url: '/client-nfs',
  title: 'Client Nfs.',
  class: 'client-nfs-side-button'
}, {
  url: '/projects',
  title: 'Projects',
  class: 'projects-side-button'
}, {
  url: '/customers',
  title: 'Customers',
  class: 'customers-side-button'
}, {
  url: '/orders/list',
  title: 'Materials/Order',
  class: 'orders-side-button'
}, {
  url: '/timesheets',
  title: 'Timesheets',
  class: 'timesheets-side-button'
}, {
  url: '/users',
  title: 'Users',
  class: 'users-side-button'
}, {
  url: '/logistic',
  title: 'Logistic',
  class: 'logistic-header-button'
}, {
  url: '/reports',
  title: 'Reports',
  class: 'reports-side-button'
}, {
  url: '/admin-panel',
  title: 'Admin Panel',
  class: 'admin-side-button'
}]
